import {
  ClickableSubtitle,
  Contact,
  ContactSubtitle,
} from '@rumblefish/ui/Rumblefish23Theme';
import { contactFormId } from '../const';

const SubtitleComponent = () => (
  <>
    <ContactSubtitle
      variant="regular_500"
      width={{ xs: '100%', md: '55%', xl: '75%' }}>
      Ready to build a state-of-the-art Web3 product? You’ll need a trusted
      partner who knows how to do it - enter the expert bunch of Rumble Fish!
      <br />
      Let's talk about your requirements and start working on launching your
      product now!
    </ContactSubtitle>

    <ContactSubtitle variant="regular_300">
      Fill out the form or schedule an introductory call now:
      <br />
      <ClickableSubtitle
        color="orange"
        link={'https://bit.ly/rf-sylwia-meeting'}
        target="_blank"
        rel="noopener noreferrer">
        Yes, let's set up a meeting!
      </ClickableSubtitle>
    </ContactSubtitle>
  </>
);

export const ContactSCD = () => {
  return (
    <Contact
      id={contactFormId}
      color="orange"
      title="Let’s develop smart contract architecture together!"
      subtitleComponent={<SubtitleComponent />}
    />
  );
};
